import React, { useEffect, useState } from "react";
import { Input, LabelText, Text, FlexContainer, InputWrapper } from "../../design";
import { INDIAN_STATES, USA_STATES } from "../../appconstants";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Select from "react-select";
import { ErrorMessage } from "@hookform/error-message";

const postalCodes = require('postal-codes-js');

type Props = {
  control: any,
  errors: any,
  alpha2: String,
  billStatesList: Array,
  isBillingAdressRequired: Boolean,
  defaultCountry: Any,
  countryNameCode: String,
}

const Address = (props: Props) => {
  const { control, errors, alpha2, billStatesList, defaultCountry, countryNameCode, isBillingAdressRequired } = props;
  const [postalCode, setPostalCode] = useState('Area Pincode');
  const [maxLength, setMaxLength] = useState(5);
  const [pincodeLabel, setPincodeLabel] = useState('Pincode');

  const isZipcodeValidate1 = (data: string) => {
    const cuntryCode = countryNameCode || (defaultCountry && defaultCountry.code);
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  useEffect(() => {
    if (alpha2 === 'IN') {
      setPostalCode('Area Pincode');
      setMaxLength(6);
      setPincodeLabel('Pincode');
    } else if (alpha2 === 'US') {
      setPostalCode('Area Zipcode');
      setMaxLength(5);
      setPincodeLabel('Zipcode');
    } else {
      setPostalCode('Area Zipcode');
      setMaxLength(5);
      setPincodeLabel('Zipcode');
    }
  }, [alpha2]);

  const customStyles = {
    control: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      marginTop: "0px",
      marginBottom: "0px",
      width: "268px",
      border: "none",
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      border: "none",
    })
  };
  return (
    <>
      <div class="row">
        <div class="col-sm">
          <LabelText>
            Address
          </LabelText>
          <Controller
            defaultValue={''}
            marginBottom="0px"
            marginTop="8px"
            borderDown="none"
            borderRadius="4px 4px 0px 0px"
            control={control}
            name="address"
            placeholder="Street Address"
            rules={{
              required: 'Street Address is required'
            }}
            color={errors.address ? "red" : "inherit"}
            as={<Input />}
          />
          <FlexContainer>
            <Controller
              defaultValue={""}
              color={errors.city ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="city"
              placeholder="City"
              rules={{
                required: 'City is required'
              }}
              as={<Input
                style={
                  {
                    marginTop: "0px",
                    marginBottom: "0px",
                    width: "298px",
                    borderRadius: "0px 0px 4px 4px",
                  }
                }
              />}
            />
          </FlexContainer>
          <ErrorMessage
            errors={errors}
            name="address"
            render={({ message }) => (
              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
            )}
          />
          <ErrorMessage
            errors={errors}
            name="city"
            render={({ message }) => (
              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
            )}
          />
        </div>
        <div class="col-sm">
          <LabelText>
            State or Region
          </LabelText>
          <InputWrapper marginTop="8px" width='299px' borderDown="none !important" paddingRight='5px' borderRadius="4px 4px 0px 0px">
            {
              isBillingAdressRequired ? (
                <Controller
                  defaultValue={""}
                  color={errors.state ? "red" : "inherit"}
                  marginBottom="0px"
                  marginTop="8px"
                  border="0px !important"
                  control={control}
                  name="state"
                  placeholder="Select state"
                  rules={{
                    required: 'State is required'
                  }}
                  as={<Select
                    theme={theme => ({
                      ...theme,
                      borderRadius: "4px 0 0 4px",
                      boxShadow: 0,
                    })}
                    // menuIsOpen={true}
                    menuPlacement="auto"
                    styles={customStyles}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.isoCode}
                    options={billStatesList} />}
                />
              ) : (
                <Controller
                  defaultValue={""}
                  color={errors.state ? "red" : "inherit"}
                  marginBottom="0px"
                  marginTop="8px"
                  border="0px !important"
                  control={control}
                  name="state"
                  placeholder="Select state"
                  rules={{
                    required: 'State is required'
                  }}
                  as={<Select
                    theme={theme => ({
                      ...theme,
                      borderRadius: "4px 0 0 4px",
                      boxShadow: 0,
                    })}
                    // menuIsOpen={true}
                    menuPlacement="auto"
                    styles={customStyles}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.code}
                    options={alpha2 === "IN" ? INDIAN_STATES : USA_STATES} />}
                />
              )
            }
          </InputWrapper>
          <FlexContainer>
            {
              isBillingAdressRequired ? (
                <Controller
                  defaultValue={""}
                  color={errors.postalCode ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="postalCode"
                  placeholder={postalCode}
                  rules={{
                    required: `${pincodeLabel} is required`,
                    validate: isZipcodeValidate1
                  }}
                  as={<Input
                    type="text"
                    name="postalCode"
                    placeholder="Enter your card number"
                  />}
                  customInput={Input} style={
                    {
                      marginTop: "0px",
                      marginBottom: "0px",
                      width: "299px",
                      borderRadius: "0px 0px 4px 4px",
                    }
                  }
                />
              ) : (
                <Controller
                  defaultValue={""}
                  color={errors.postalCode ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="postalCode"
                  placeholder={postalCode}                  
                  rules={{
                    required: `${pincodeLabel} is required`,
                    minLength: { value: 5, message: `Postal code must be ${maxLength} characters` }
                  }}
                  as={<NumberFormat minLength={5} maxLength={maxLength} allowNegative={false} decimalScale={0} />}
                  customInput={Input} style={
                    {
                      marginTop: "0px",
                      marginBottom: "0px",
                      width: "299px",
                      borderRadius: "0px 0px 4px 4px",
                    }
                  }
                />
              )
            }
          </FlexContainer>
          <ErrorMessage
            errors={errors}
            name="state"
            render={({ message }) => (
              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
            )}
          />
          <ErrorMessage
            errors={errors}
            name="postalCode"
            render={({ message }) => (
              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
            )}
          />
        </div>
      </div>
    </>
  )
};


export default Address;
